import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

export const PhotoThumbs = ({ photos, testIdPrefix, sizeClass = "w-16 h-16", className = "" }) => {
  const [open, setOpen] = useState(null);
  if (!photos || photos.length === 0) return null;
  return (
    <>
      <div className={`flex gap-2 flex-wrap ${className}`} data-testid={`${testIdPrefix}-list`}>
        {photos.map((p, i) => (
          <button type="button" key={i} onClick={(e) => { e.stopPropagation(); setOpen(p); }} data-testid={`${testIdPrefix}-${i}`}>
            <img src={p} alt="Completed cut" className={`${sizeClass} object-cover rounded-lg border border-[#27272A] hover:border-[#39FF14] transition-colors`} />
          </button>
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="bg-[#0A0A0A] border-[#27272A] max-w-3xl p-2" data-testid={`${testIdPrefix}-viewer`}>
          <DialogTitle className="sr-only">Cut photo</DialogTitle>
          {open && <img src={open} alt="Completed cut full size" className="w-full max-h-[80vh] object-contain rounded-md" />}
        </DialogContent>
      </Dialog>
    </>
  );
};
